import { Select } from "@mantine/core"
import { useTranslation } from "react-i18next"
import useSWR from "swr";
import { BranchApi } from "../../apis";
import HttpHandler from "../../utils/http-handler";
import { message } from "../../utils/message";

export function BranchForm({ id, values, setFieldValue, index }: { id: any; values: any; setFieldValue: any; index: any }) {
  const { t } = useTranslation(["common"])
  const { data } = useSWR(`/ord/branch/select/${id}/${index}`, async () => {
    try {
      let res = await BranchApi.select({ businessId: id[index]?.buyerBusinessId });
      return res;
    } catch (err) {
      message.error((err as HttpHandler)?.message!);
    }
  });

  return (
    <Select
      size="sm"
      value={values?.lines?.[index]?.receiverBranchId ?? null}
      onChange={(v) => setFieldValue(`lines.${index}.receiverBranchId`, v)}
      placeholder={t("common:filter.selectPlaceholder")}
      data={(data || []).map((c: any) => ({
        label: c.name,
        value: c.id,
      }))}
      clearable
    />
  );
}
